module.exports = __webpack_public_path__ + "AvertaStd-Extrathin.svg?61499468958e9be3b56ce8f0ee963d29";